import React from "react";
import Form from "./Form";
import { Box } from "@mui/material";

const Index = ({
  goalVideos,
  setGoalVideos,
  setDeletedVideos,
  addTournamentFormSubmited,
  isAdmin,
}) => {
  return (
    <Box style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
      {goalVideos.map((data, index) => {
        return (
          <Form
            key={data.key_Id}
            data={data}
            index={index}
            setGoalVideos={setGoalVideos}
            setDeletedVideos={setDeletedVideos}
            goalVideos={goalVideos}
            addTournamentFormSubmited={addTournamentFormSubmited}
            isAdmin={isAdmin}
          />
        );
      })}
    </Box>
  );
};

export default Index;
